import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disablePointerEvents", "loading", "onClick", "position", "classes", "children", "theme", "invalid", "as", "loader"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import styles from './FieldIcon.css';
var cx = classNames.bind(styles);
export var FieldIcon = /*#__PURE__*/forwardRef(function FieldIcon(_ref, ref) {
  var _cx;

  var disablePointerEvents = _ref.disablePointerEvents,
      loading = _ref.loading,
      onClick = _ref.onClick,
      position = _ref.position,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      children = _ref.children,
      theme = _ref.theme,
      invalid = _ref.invalid,
      as = _ref.as,
      loader = _ref.loader,
      rest = _objectWithoutProperties(_ref, _excluded);

  var Tag = 'button';
  var isNotActive = disablePointerEvents || loading || !onClick;

  if (as) {
    Tag = as;
  } else if (isNotActive) {
    Tag = 'div';
  }

  return /*#__PURE__*/React.createElement(Tag, _extends({}, rest, {
    ref: ref,
    type: Tag === 'button' ? 'button' : undefined,
    className: cx('root', "theme_".concat(theme), (_cx = {}, _defineProperty(_cx, "position_".concat(position), position), _defineProperty(_cx, "invalid", invalid), _defineProperty(_cx, "disabled", isNotActive), _cx), classes === null || classes === void 0 ? void 0 : classes.root),
    onClick: onClick
  }), loading ? loader : children);
});
export default FieldIcon;